module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/fork-spoon-bd2b5d586b5663c1974eaffc0b73679e.svg";